import React, { useEffect } from 'react';
import { breakpoints } from '@chegg-ui/theme';
import { initializeRioClient } from '@chegg-me-components/utils';
import Media from 'react-media';
import DesktopHeader from '../components/desktop/desktopHeader';
import MobileHeader from '../components/mobile/mobileHeader';
import { HeaderShell } from '../components/shared';
import { HeaderContext, defaultContext } from '../shared';
import { SearchContainer } from '../styles/root';
import { HideSearchBar } from '../types/root';

var SignedOutHeader = function SignedOutHeader(_ref) {
  var activeLink = _ref.activeLink,
      logo = _ref.logo,
      children = _ref.children,
      className = _ref.className,
      dataTest = _ref['data-test'],
      envUrl = _ref.envUrl,
      mainContentId = _ref.mainContentId,
      navLinks = _ref.navLinks,
      secondaryNavLinks = _ref.secondaryNavLinks,
      showBorder = _ref.showBorder,
      scrollWithPage = _ref.scrollWithPage,
      serverRenderAsMobile = _ref.serverRenderAsMobile,
      onClickLogo = _ref.onClickLogo,
      onCloseHamburger = _ref.onCloseHamburger,
      onOpenHamburger = _ref.onOpenHamburger,
      rioConfig = _ref.rioConfig;
  useEffect(function () {
    initializeRioClient(rioConfig);
  }, []);
  var contextValue = {
    envUrl: envUrl,
    dataTestPrefix: dataTest !== null && dataTest !== void 0 ? dataTest : defaultContext.dataTestPrefix
  };
  return /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(HeaderShell, {
    mainContentId: mainContentId,
    scrollWithPage: scrollWithPage,
    "data-test": dataTest ? dataTest : defaultContext.dataTestPrefix,
    className: className
  }, /*#__PURE__*/React.createElement(Media, {
    query: {
      maxWidth: breakpoints.md.max
    },
    defaultMatches: !!serverRenderAsMobile
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(MobileHeader, {
      activeLink: activeLink,
      logo: logo,
      navLinks: navLinks,
      secondaryNavLinks: secondaryNavLinks,
      onClickLogo: onClickLogo,
      onCloseHamburger: onCloseHamburger,
      onOpenHamburger: onOpenHamburger
    }) : /*#__PURE__*/React.createElement(DesktopHeader, {
      activeLink: activeLink,
      logo: logo,
      navLinks: navLinks,
      secondaryNavLinks: secondaryNavLinks,
      onClickLogo: onClickLogo
    });
  })), children !== HideSearchBar && /*#__PURE__*/React.createElement(SearchContainer, {
    "data-test": "".concat(defaultContext.dataTestPrefix, "-search-container"),
    showBorder: showBorder
  }, children));
};

SignedOutHeader.displayName = 'SignedOutHeader';
export default SignedOutHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/signed-out-header/dist/esm/variants/SignedOutHeader.js
// module id = 5626
// module chunks = 11